import remoteLoad from '../common';

class Linkedme {
  constructor(key, options = {}) {
    this.key = key;
    this.options = options;
  }

  // 获取Linkedme对象
  getLinkedme() {
    return new Promise((resolve) => {
      (async () => {
        if (this.instance) {
          resolve(this.instance);
        } else {
          await remoteLoad('https://static.lkme.cc/linkedme.min.js');
          this.instance = window.linkedme;
          this.instance.init(this.key, this.options, (err) => {
            if (err) {
              console.error(err);
            } else {
              resolve(this.instance);
            }
          });
        }
      })();
    });
  }

  // 获取深度链接
  getLink(params, options = {}, autoOpen = false) {
    return new Promise((resolve, reject) => {
      (async () => {
        const linkedme = await this.getLinkedme();
        linkedme.link({
          params: params ? JSON.stringify(params) : undefined,
          ...options,
        }, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res.url);
          }
        }, autoOpen);
      })();
    });
  }

  // 唤醒APP
  awaken(params, options) {
    return this.getLink(params, options, true);
  }
}

export default Linkedme;
